import * as countryStatePicker from 'country-state-picker';
import countries from './countries.json';
import states from './states.json';

export type Country = {
  name: string;
  code: string;
  dial_code: string;
};
type CountryFieldName = keyof Country;

const extraCountries: Country[] = countries;
const extraStates: Record<string, string[]> = states;

function getExtraCountry(code: string): Country | null {
  return extraCountries.find((country: Country): boolean => {
    const countryFieldNames: CountryFieldName[] = Object.keys(country) as CountryFieldName[];
    return countryFieldNames.some((countryFieldName: CountryFieldName): boolean => (
      country[countryFieldName].toLowerCase() === code.toLowerCase()
    ));
  }) || null;
}

function getExtraCountries(): Country[] {
  return extraCountries || [];
}

function getExtraStates(code: string): string[] {
  return extraStates[code] || [];
}

export function getCountry(code: string): Country | null {
  if (!code) {
    return null;
  }
  return countryStatePicker.getCountry(code) || getExtraCountry(code);
}

export function getCountries(): Country[] {
  return countryStatePicker.getCountries().concat(getExtraCountries());
}

export function getStates(code: string): string[] {
  const selectedCountry: Country | null = getCountry(code);

  if (selectedCountry) {
    return countryStatePicker.getStates(selectedCountry.code) || getExtraStates(selectedCountry.code);
  }
  return [];
}

export function hasStates(country: string): boolean {
  return country === 'us';
}
